var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M24-.003H0v15.998h24V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M24-.003H0V5.33h24V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#496E2D",
    d: "M24 10.662H0v5.333h24v-5.332z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M13.193 7.063l.42.577.682-.217-.42.577.412.578-.675-.218-.42.578v-.72L12.51 8l.683-.225v-.713z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12.045 9.448a1.447 1.447 0 11.705-2.723 1.777 1.777 0 100 2.55c-.217.113-.46.173-.705.173z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLy);
export default __webpack_public_path__ + "static/media/ly.f833ae3f62168384b9b683a8587321a0.svg";
export { ForwardRef as ReactComponent };